// Copyright (c) 2017 Deere & Company

import allClaims from './all-claims';
import busyCounter from '../../../shared/reducers/busy-counter';
import claimsAccordion from './toggle-accordion';
import {combineReducers} from 'redux';
import createClaimModal from './create-claim';
import facets from './facets';
import hasSearchResults from '../../shared/reducers/has-search-results';
import reportsAccordion from './reports-accordion';
import searchByDropDown from '../../shared/reducers/search-by-dropdown';
import searchFilters from './search-filters';
import searchQueryString from '../../shared/reducers/search-query-string';

export const getCombinedReducers = () => combineReducers({
    allClaims,
    busyCounter,
    claimsAccordion,
    createClaimModal,
    facets,
    hasSearchResults,
    reportsAccordion,
    searchByDropDown,
    searchFilters,
    searchQueryString
});



// WEBPACK FOOTER //
// ./src/claim/all-claims/reducers/index.js